import { AxiosResponse } from "axios";
import { Axios } from "../Axios";
import { TypeCentroCustoTipo } from "../../Models/Financeiro/CentroCustoTipo";

export class CentroCustoTipoService {
    public listar(tipo: TypeCentroCustoTipo): Promise<AxiosResponse<TypeCentroCustoTipo[]>> {
        return Axios.post<TypeCentroCustoTipo[]>(`CentroCustoTipo/listar`, tipo);
    }
}